import {autoTableColumnLabels} from "@/features/i18n/autoTableColumns";
import {Input} from "@/shared/components/ui/input";
import React from "react";
import {AutoTableInterface} from "@/features/types/AutoTableInterface";
import {getAutoDetailsDisplayValue} from "../autoDetailsUtils";

const vehicleFieldCols: Record<number, Array<keyof AutoTableInterface>> = {
    1: [
        "f_ord_num",
        "f_ord_d",
        "f_vin",
        "f_sales_type",
        "f_prd_year",
        "f_sales_registr",
        "f_sales_registr_dat",
        "f_veh_sec_1",
        "f_veh_grp_1",
        "f_veh_make",
        "f_veh_desc_1",
    ],
    2: [
        "f_svo_code_1",
        "f_svo_code_2",
        "f_svo_code_3",
        "f_svo_code_4",
        "f_svo_code_5",
        "f_svo_code_6",
        "f_svo_code_7",
        "f_svo_code_8",
        "f_svo_code_9",
    ],
};

export interface AutoDetailsVehicleTabProps {
    data: AutoTableInterface;
}

export const AutoDetailsVehicleTab = ({data}: AutoDetailsVehicleTabProps) => {
    return (
        <div className="flex flex-col gap-3">
            <div
                className="flex flex-col gap-2 sm:gap-3 md:gap-4 xl:grid xl:grid-cols-[minmax(0,1fr)_minmax(280px,360px)] xl:gap-x-8">
                <div className="order-1 xl:order-2 min-w-0">
                    <div className="mx-auto w-full max-w-[320px] xl:max-w-none">
                        <div
                            className="flex aspect-[4/3] items-center justify-center rounded-md border bg-muted/20 text-left text-xs text-muted-foreground">
                            Zdjęcie pojazdu
                        </div>
                    </div>
                </div>
                <div className="order-2 xl:order-1 min-w-0">
                    <div
                        className="grid grid-cols-1 gap-3 md:grid-cols-[minmax(320px,1fr)_minmax(320px,1fr)] md:gap-x-4 lg:gap-x-6">
                        {[1, 2].map((col) => (
                            <div key={col} className="flex min-w-0 flex-col gap-3">
                                {vehicleFieldCols[col].map((key) => (
                                    <div
                                        key={key}
                                        className="grid w-full min-w-0 grid-cols-[120px_minmax(200px,1fr)] items-center gap-1 text-left"
                                    >
                                        <span className="text-sm text-muted-foreground truncate">
                                            {autoTableColumnLabels[key] ?? key}
                                        </span>
                                        <Input
                                            readOnly
                                            value={getAutoDetailsDisplayValue(data, key)}
                                            className="h-8 w-full min-w-0 bg-muted/10"
                                        />
                                    </div>
                                ))}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}



